import { forwardRef } from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import {
  SEPARATOR_DEFAULTS,
  SEPARATOR_ORIENTATION_CLASS_MAP,
  type TSeparatorElement,
  type TSeparatorProps,
} from "@/ui/components/primitives/Separator/Separator.config";
import { cn } from "@/ui/lib/utils";

export const Separator = forwardRef<TSeparatorElement, TSeparatorProps>(
  (
    {
      className,
      orientation = SEPARATOR_DEFAULTS.orientation,
      decorative = SEPARATOR_DEFAULTS.decorative,
      ...props
    },
    ref,
  ) => (
    <SeparatorPrimitive.Root
      data-component="Separator"
      ref={ref}
      orientation={orientation}
      decorative={decorative}
      {...props}
      className={cn(
        "shrink-0 border-muted",
        SEPARATOR_ORIENTATION_CLASS_MAP[orientation],
        className,
      )}
    />
  ),
);

Separator.displayName = "Separator";
